import { IsAdmin, SID, CID } from '@state';
import { useRecoilValue } from 'recoil';

export const useWithImpersonation = (customer: 'shipper' | 'carrier', isLinkedRateCard: boolean = false) => {
	const isAdmin = useRecoilValue(IsAdmin);
	const sID = useRecoilValue(SID);
	const cID = useRecoilValue(CID);
	const routeWithImpersonation = (url: string) => {
		const currentURL = window.location.origin;
		const theURL = new URL(url, currentURL);
		// slice the '?' from the string
		const params = theURL.search.length ? theURL.search.slice(1) : ''
		if (!isAdmin) return url;
		if (customer === 'shipper' && sID) {
			return `${theURL.pathname}?sid=${sID}&isLinkedRateCard=${isLinkedRateCard}&${params}`;
		} else if (customer === 'carrier' && cID) {
			return `${theURL.pathname}?cid=${cID}&isLinkedRateCard=${isLinkedRateCard}&${params}`;
		}
		return url;
	}

	return routeWithImpersonation;
}
